export default {
  title: 'Panier',
};
